import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { UserContext } from '../UserContext';
import { useParams } from 'react-router-dom';
import '../forums/Spiritual/TemplateForum.css';






const API_BASE_URL = 'https://wholeness-forward.onrender.com/api';

const GroupForumTemplate = () => {
  const { user } = useContext(UserContext);
  const { groupId } = useParams(); // ✅ Get groupId from URL
  const [threads, setThreads] = useState([]);
  const [newThreadTitle, setNewThreadTitle] = useState('');
  const [newThreadContent, setNewThreadContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchThreads = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/groupForum/${groupId}/threads`);
        setThreads(response.data);
      } catch (error) {
        console.error('Error fetching threads:', error);
        setError('Failed to load threads.');
      }
    };

    if (groupId) {
      fetchThreads();
    }
  }, [groupId]);

  const handlePostThread = async (e) => {
    e.preventDefault();
    if (!user) {
      setError('You must be logged in to post a thread.');
      return;
    }

    setLoading(true);
    try {
      await axios.post(
        `${API_BASE_URL}/groupForum/${groupId}/threads`,
        { title: newThreadTitle, content: newThreadContent },
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
      setNewThreadTitle('');
      setNewThreadContent('');
      window.location.reload(); // Refresh threads after posting
    } catch (error) {
      console.error('Error posting thread:', error);
      setError('Failed to post thread.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p>Loading forum...</p>;
  if (error) return <p className="error">{error}</p>;

  return (
    <div className="forum-container">
      <h1>Group Forum</h1>

      {user && (
        <div className="new-thread-form">
          <h3>Post a New Thread</h3>
          <form onSubmit={handlePostThread}>
            <input
              type="text"
              placeholder="Thread Title"
              value={newThreadTitle}
              onChange={(e) => setNewThreadTitle(e.target.value)}
            />
            <textarea
              placeholder="What's on your mind?"
              value={newThreadContent}
              onChange={(e) => setNewThreadContent(e.target.value)}
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Posting...' : 'Post Thread'}
            </button>
          </form>
        </div>
      )}

      <div className="threads-list">
        {threads.map((thread) => (
          <div key={thread._id} className="thread-card">
            <h4>{thread.title}</h4>
            <p>Posted by: {thread.username}</p>
            <p>{thread.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GroupForumTemplate;
